module.exports = __webpack_public_path__ + "media/app/assets/hero-background-main-f37d112781314e2484b7ea3d86921460.png";